import { Account } from '../types/Account'

const accountEndpoints = {
  list: (companyId: string) => `/companies/${companyId}/accounting/accounts` as const,
  detail: (companyId: string, code: Account['code']) => `/companies/${companyId}/accounting/accounts/${code}` as const,
  budgets: (companyId: string) => `/companies/${companyId}/budgeting/budget-deltas` as const
}

export default accountEndpoints
